import React from 'react'
import injectSheet from 'react-jss'
import { Row, Col } from 'react-flexbox-grid'
import { Link } from 'react-router-dom'


import calendar from '../img/calendarBig@2x.png'
import about from '../img/aboutBig@2x.png'
import help from '../img/helpBig@2x.png'
import location from '../img/set-locationBig@2x.png'

const styles = {
	root: {
		maxWidth: '1250px',
		height: '500px',
		margin: '2% auto 0',
		background: '#f0f0f0'
	},
	containerButton: {
		borderRadius: '4px'
	},
	button: {
		textDecoration: 'none',
		color: '#333333',
		fontSize: '25px',
		lineHeight: '29px'
	},
	roundImgButton: {
		width: '125px',
		height: '125px',
		position: 'relative'
	},
	aboutButton: {
		extend: 'roundImgButton',
		borderRadius: '100px',
		border: '1px solid rgba(0,0,0,0.1)',
		background: '#21C4B7'
	},
	locationButton: {
		extend: 'roundImgButton',
		borderRadius: '100px',
		border: '1px solid rgba(0,0,0,0.1)',
		background: '#11AACC'
	},
	eventsButton: {
		extend: 'roundImgButton',
		borderRadius: '100px',
		border: '1px solid rgba(0,0,0,0.1)',
		background: '#71BF39'
	},
	helpButton: {
		extend: 'roundImgButton',
		borderRadius: '100px',
		border: '1px solid rgba(0,0,0,0.1)',
		background: '#E64545'
	},
	wrapper: {
		background: '#FFFFFF',
		height: '233px',
		padding: '2% 0 0 10%',
		'&:hover': {
			cursor: 'pointer'
		}
	},
	img: {
		position: 'absolute',
		top: '19%',
		left: '19%'
	},
	infoText: {
		fontSize: '17px',
		lineHeight: '20px',
		color: '#535353',
		marginTop: '20px'
	},
	titleInfo: {
		color: '#1A1A1A',
    	fontWeight: '600'
	},
	wrapperAbout: {
		extend: 'wrapper',
		marginRight: '1%'
	},
	wrapperEvents: {
		extend: 'wrapperAbout'
	}
}

class HomePage extends React.Component {
	render() {
		const { classes, gotoUrl } = this.props
		return (
			<div >
				<Row className={classes.root}>
					<Col md={6} onClick={() => gotoUrl('about')} className={classes.containerButton}>
						<Row middle='md' className={classes.wrapperAbout}>
							<Col className={classes.aboutButton}><img src={about} className={classes.img}/></Col>
							<Col md={6} mdOffset={1} className={classes.button}>
								<div className={classes.titleInfo}>About</div>
								<div className={classes.infoText}>At UnitedCoR we aspire to a world where secular ideals are treated with respect and dignity.</div>
							</Col>
						</Row>
					</Col>
					<Col md={6} onClick={() => gotoUrl('location')} className={classes.containerButton}>
						<Row middle='md' className={classes.wrapper}>
							<Col className={classes.locationButton}><img src={location} className={classes.img}/></Col>
							<Col md={6} mdOffset={1} className={classes.button}>
								<div className={classes.titleInfo}>Set Location</div>
								<div className={classes.infoText}>Select a location and check events on a map.</div>
							</Col>
						</Row>
					</Col>
					<Col md={6} onClick={() => gotoUrl('events')} className={classes.containerButton}>
						<Row middle='md' className={classes.wrapperEvents}>
							<Col className={classes.eventsButton}><img src={calendar} className={classes.img}/></Col>
							<Col md={6} mdOffset={1} className={classes.button}>
								<div className={classes.titleInfo}>See Events</div>
								<div className={classes.infoText}>You can search events on calendar.</div>
							</Col>
						</Row>
					</Col>
					<Col md={6} onClick={() => window.location.href='https://unitedcor.org/app/'} className={classes.containerButton}>
						<Row middle='md' className={classes.wrapper}>
							<Col className={classes.helpButton}><img src={help} className={classes.img}/></Col>
							<Col md={6} mdOffset={1} className={classes.button}>
								<div className={classes.titleInfo}>Help</div>
								<div className={classes.infoText}>Quick help and links to mobile applications.</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		)
	}
}

export default injectSheet(styles)(HomePage)



// WEBPACK FOOTER //
// ./src/components/HomePage.jsx